const neverListModule = productName => ({
  title: `A highly efficacious, naturally powerful ${productName}`,
  paragraph: `Every ingredient ${
    productName ? `in your custom ${productName}` : ''
  } is selected for peak potency to deliver the best results for your skin. We use only the ingredients you need — nothing more, nothing less.`,
  cta: 'Learn about our ingredients',
  checkList: [
    { name: 'Vegan', id: 1 },
    { name: 'Cruelty-free', id: 2 },
    { name: 'Silicone-free', id: 3 },
    { name: 'Alcohol-free', id: 4 },
    { name: 'Paraben-free', id: 5 },
    { name: 'Mineral Oil-free', id: 6 },
    { name: 'Phthalate-free', id: 7 },
    { name: 'GMO-free', id: 8 },
    { name: 'Fragrance-free options', id: 9 },
  ],
});

export default neverListModule;
